import Input from '@components/forms/Input'
import Label from '@components/forms/Label'
import Button from '@components/shared/Button'
import Modal from '@components/shared/Modal'
import { useLocalStorage } from 'hooks/useLocalStorageState'
import { ChangeEvent, useState } from 'react'
import { ModalProps } from 'types/modal'
import { TRADER_ADDRESS_FILTER_KEY } from 'utils/constants'
import { useTranslation } from 'next-i18next'

const TraderFilterFormModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('trade')
  return (
    <Modal
      panelClassNames="overflow-auto thin-scroll"
      isOpen={isOpen}
      onClose={onClose}
    >
      <h2 className="mb-4 text-center">{t('filter.title.trader')}</h2>
      <TraderFilterForm onSave={onClose} />
    </Modal>
  )
}

export default TraderFilterFormModal

export const TraderFilterForm = ({ onSave }: { onSave: () => void }) => {
  const { t } = useTranslation('trade')
  const [addressToFilter, setAddressToFilter] = useLocalStorage(
    TRADER_ADDRESS_FILTER_KEY,
  )
  const [inputCount, setInputCount] = useState(addressToFilter.length || 1)
  const [addresses, setAddresses] = useState(addressToFilter)

  const handleInputChange = (index: number, value: string) => {
    const updatedFilter = [...addresses]
    updatedFilter[index] = value
    setAddresses(updatedFilter)
  }

  const handleAddInput = () => {
    setInputCount((prevInputCount: number) => prevInputCount + 1)
  }

  const handleFilter = () => {
    setAddressToFilter(addresses)
    onSave()
  }

  const handleClear = () => {
    setInputCount(1)
    setAddressToFilter([])
    onSave()
  }
  return (
    <>
      <div className="space-y-3">
        {Array.from({ length: inputCount }, (_, i) => (
          <div key={i}>
            <Label
              text={t('filter.trader.wallet-address', { number: i + 1 })}
            />
            <Input
              type="text"
              placeholder={t('filter.trader.placeholder')}
              value={addresses[i] || ''}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                handleInputChange(i, e.target.value)
              }
            />
          </div>
        ))}
      </div>
      <div className="flex justify-end space-x-2 pt-4">
        <Button onClick={() => handleFilter()}>
          {t('filter.trader.apply')}
        </Button>
        <Button onClick={handleAddInput} secondary>
          {t('filter.trader.add')}
        </Button>
        <Button onClick={() => handleClear()} secondary>
          {t('filter.trader.clear')}
        </Button>
      </div>
    </>
  )
}
